import axios from 'axios';

const api = axios.create({
  baseURL: 'https://server.terence.app'
//  baseURL: 'http://localhost:3333'
});

export default api;
